export const TranslationIdMap = '';

export const TranslationKeyMap = {
    '__CALL_IN_PROGRESS': 'Call in progress',
    '__REJOIN_CALL': 'Rejoin call',
    '__END_CALL': 'End call'
};
